import { create } from "zustand";
import { logger } from "./logger";
const initialState = {
    geofenceList: [],
    projectId: "",
    projectName: ""
};
const useProjectGeoFenceStore = create()(logger((set, get) => ({
    ...initialState,
    deleteGeofence: (geofenceId) => {
        set((state) => ({
            geofenceList: state.geofenceList.filter((g) => g.geofenceId !== geofenceId)
        }));
    },
    getGeofenceCoordinates: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.coordinates;
    },
    getGeofenceInfo: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence;
    },
    getGeofenceModeType: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.modeType;
    },
    getGeofenceName: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.geofenceName;
    },
    getGeofenceType: (geofenceId) => {
        const geofence = get().geofenceList?.find((g) => g.geofenceId === geofenceId);
        return geofence?.geofenceType;
    },
    resetGeofenceState: () => {
        set(() => ({
            geofenceList: [],
            projectId: null,
            projectName: null
        }));
    },
    setGeofenceCoordinates: (geofenceId, coordinates) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, coordinates } : g)
        }));
    },
    setGeofenceDesc: (geofenceId, description) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, description } : g)
        }));
    },
    setGeofenceIdModeType: (tempGeofenceId, newGeofenceId) => {
        set({
            geofenceList: get().geofenceList.map((g) => g.geofenceId === tempGeofenceId ? { ...g, geofenceId: newGeofenceId, modeType: "edit" } : g)
        });
    },
    setGeofenceList: (newGeoFences) => {
        set((state) => ({
            geofenceList: [...state.geofenceList, ...newGeoFences]
        }));
    },
    setGeofenceName: (geofenceId, geofenceName) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, geofenceName } : g)
        }));
    },
    setGeofenceType: (geofenceId, geofenceType) => {
        set((state) => ({
            geofenceList: state.geofenceList.map((g) => g.geofenceId === geofenceId ? { ...g, geofenceType } : g)
        }));
    },
    setProjectGeofenceInfo: (projectGeofenceInfo) => {
        set(() => ({
            geofenceList: projectGeofenceInfo.geofenceList,
            projectId: projectGeofenceInfo.projectId,
            projectName: projectGeofenceInfo.projectName
        }));
    }
}), "ProjectGeoFenceStore"));
export default useProjectGeoFenceStore;
